import React from "react"

const HRIcon = () => {
  return (
      <svg
        width="23"
        height="22"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 0.5H22V21.5H1V0.5Z" fill="black" />
        <path
          d="M21.3848 18.3418H1.61523V9.31836H21.3848V18.3418Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.39844 11.7793V15.8809"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2327 11.7793V15.8809"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.39844 13.7598H10.2368"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0586 13.9233L14.7815 15.8809"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5625 11.7793V15.8809"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7826 12.8434C14.7826 13.4321 14.2664 13.9093 13.6564 13.9093C13.3538 13.9093 12.574 13.9141 12.574 13.9141C12.574 13.9141 12.5691 13.1401 12.5691 12.8434C12.5691 12.5997 12.5664 11.7774 12.5664 11.7774H13.6564C14.2664 11.7774 14.7826 12.2547 14.7826 12.8434Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.1133 5.2168H15.6016L13.9609 9.31836H18.4727L20.1133 5.2168Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.21875 5.2168H6.57813C4.99246 5.2168 3.70703 6.50223 3.70703 8.08789V9.31836H11.0898V8.08789C11.0898 6.50223 9.80441 5.2168 8.21875 5.2168Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.44922 3.16602C9.44922 4.29862 8.53104 5.2168 7.39844 5.2168C6.26583 5.2168 5.34766 4.29862 5.34766 3.16602C5.34766 2.03341 6.26583 1.11523 7.39844 1.11523C8.53104 1.11523 9.44922 2.03341 9.44922 3.16602Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.34766 20.8848H2.88672V18.3418H5.34766V20.8848Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6523 20.8848H20.1133V18.3418H17.6523V20.8848Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
  )
}

export default HRIcon
